import { Box, CircularProgress } from '@mui/material';
import { Dialog, DialogContent } from '@mui/material';
import { ReactElement } from 'react';

export default function CenteredLoadingDisplay(): ReactElement {
  return (
    <Dialog
      open
      sx={{
        '& .MuiPaper-root': {
          backgroundColor: 'initial',
          boxShadow: 'none',
        },
      }}
    >
      <DialogContent>
        <Box sx={{ color: 'white' }}>
          <CircularProgress size={50} color="inherit" />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
